import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppResponse } from '@data/app/response';
import { environment } from '@environments/environment';
import { ApiPaths } from '@mpg-core/constants/api-paths.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ManageUsersPSRGrpService {

  constructor(private http: HttpClient){}

  getPSRGroups(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getAllUserGroups).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getPSRGrpUsers(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getAllUsersWithGroups).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  deletPSRGrpUser(payload:any){
      return this.http.post<any>(environment.apiUrl+ ApiPaths.deleteUserFromGroup, payload ).pipe(
        map((res: AppResponse) => {
          return res;
        })
      );
    }

    savePSRGrpUser(payload:any): Observable<any> {
      return this.http.post<any>(environment.apiUrl+ ApiPaths.saveUserGroupDetails, payload ).pipe(
        map((res: AppResponse) => {
          return res;
        })
      );
    }

}
